import { createStore, applyMiddleware, compose } from 'redux'
// import { createBrowserHistory, createHashHistory } from 'history'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import thunk from 'redux-thunk'
import { offline } from '@redux-offline/redux-offline'
import offlineConfig from './offline-config'
import { offlineStatus } from 'redux-offline-status'

import createRootReducer from './reducers'

const configureHistory = () => {
  // return window.matchMedia('(display-mode: standalone)').matches
  //   ? createHashHistory()
  //   : createBrowserHistory()
  return createBrowserHistory()
}

export const history = configureHistory()
const initialState = {}
const enhancers = []
const middleware = [thunk, routerMiddleware(history), offlineStatus()]

if (process.env.REACT_APP_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  offline(offlineConfig),
  ...enhancers,
)

export default createStore(createRootReducer(history), initialState, composedEnhancers)
